import { Outlet, useParams } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { AppProvider } from '../context/AppContext';
import { useGetInsuranceParams } from '../hooks/useWizard';
import { useGetInsuranceParams as useGetInsuranceParamsTravel } from '../hooks/useWizard';
import { createContext, useContext, useEffect, useState } from 'react';
import { InsuranceParamsDto, InsuranceParamsPropertyDto, InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos';
import { AxiosError } from 'axios';
import { useGetInsuranceParamsAddon } from '../hooks/useWizardAddon';
import { IAvailableApps } from '../utils/availableApps';
import { useApp } from '../hooks/useApp';

export type insuranceParamsContextProps = {
    isLoadingData: boolean
    isLoading: boolean
    insuranceParamsId: string | undefined
    refetchInsuranceParams: () => Promise<any>
    insuranceParams?: InsuranceParamsDto | InsuranceParamsTravelDto | InsuranceParamsPropertyDto
    triggerNewInsurance: boolean
    setTriggerNewInsurance: (value: boolean) => void
    error?: AxiosError<any>
}
export const insuranceParamsContext = createContext<insuranceParamsContextProps>({} as insuranceParamsContextProps);

export interface WizzardLayoutProps {
    app: IAvailableApps['appId']
}

const WizardLayoutContent = () => {
    const { app } = useApp()
    let { insuranceParamsId } = useParams()

    const paramsId = insuranceParamsId == "0" ? undefined : insuranceParamsId

    const { isLoading: isLoadingVeh, isFetching: isFetchingVeh, data: step1DataVeh, refetch: refetchVeh, error: errorVeh } = useGetInsuranceParams(paramsId ?? '', { enabled: false, cacheTime: 0 });
    const { isLoading: isLoadingTra, isFetching: isFetchingTra, data: step1DataTra, refetch: refetchTra, error: errorTra } = useGetInsuranceParamsTravel(paramsId ?? '', { enabled: false, cacheTime: 0 });
    const { isLoading: isLoadingAdd, isFetching: isFetchingAdd, data: step1DataAdd, refetch: refetchAdd, error: errorAdd } = useGetInsuranceParamsAddon(paramsId ?? '', { enabled: false, cacheTime: 0 });

    let isLoading = isLoadingVeh;
    let isFetching = isFetchingVeh;
    let step1Data: any = step1DataVeh;
    let refetch: any = refetchVeh;
    let error: any = errorVeh;

    if (app === 'carkulka-extra') {
        isLoading = isLoadingAdd;
        isFetching = isFetchingAdd;
        step1Data = step1DataAdd;
        refetch = refetchAdd;
        error = errorAdd;
    }
    else if (app === 'cestovko') {
        isLoading = isLoadingTra;
        isFetching = isFetchingTra;
        step1Data = step1DataTra;
        refetch = refetchTra;
        error = errorTra;
    }

    const [triggerNewInsurance, setTriggerNewInsurance] = useState(false);

    // nacteni infa o nabidce
    useEffect(() => {
        if (!!paramsId)
            refetch();
    }, [paramsId]);

    return (
        <insuranceParamsContext.Provider value={{
            insuranceParamsId: paramsId,
            isLoadingData: isLoading || isFetching,
            isLoading: isLoading,
            refetchInsuranceParams: refetch,
            insuranceParams: step1Data?.data,
            triggerNewInsurance: triggerNewInsurance,
            setTriggerNewInsurance: setTriggerNewInsurance,
            error: error
        }}>
            <Header />

            <Outlet />

            <Footer />
        </insuranceParamsContext.Provider>
    )
}

export const WizardLayout = ({ app }: WizzardLayoutProps) => {
    return (
        <AppProvider app={app}>
            <WizardLayoutContent />
        </AppProvider>
    )
}

export const useInsuranceParamsContext = () => {
    const context = useContext(insuranceParamsContext)

    if (context === undefined || Object.keys(context).length == 0) {
        throw new Error('useInsuranceParamsContext must be used within a insuranceParamsContext!')
    }

    return context
}